/**
   * API for managing allowed sellers for a buyer in a specific category
   * Base URL: /api/v1/user-accounts/traffic/buyer/{buyerId}/category/{categoryId}
   */
import createHttpClient from './httpClient'

const baseUrl = new URL('/api/v1/user-accounts/traffic/buyer', process.env.VUE_APP_INTERNAL_SERVICE_BASE_URL).href
const httpClient = createHttpClient(baseUrl)

const BuyerCategoryTrafficControlAPI = {
  /**
   * Get allowed sellers for a buyer in a specific category
   *
   * @route GET traffic/buyer/{buyerId}/category/{categoryId}
   * @param {string} buyerId - The ID of the buyer account
   * @param {string} categoryId - The ID of the category
   * @returns {Array<{id: string, name: string}>} - List of allowed seller accounts with their IDs and names
   */
  getAllowedSellers(buyerId, categoryId) {
    return httpClient.get(`${buyerId}/category/${categoryId}`)
  },

  /**
   * Set allowed sellers for a buyer in a specific category
   *
   * @route POST traffic/buyer/{buyerId}/category/{categoryId}
   * @param {string} buyerId - The ID of the buyer account
   * @param {string} categoryId - The ID of the category
   * @param {Array<string>} sellerIds - List of seller IDs to allow
   * @returns {Object} - Success or failure response
   */
  setAllowedSellers(buyerId, categoryId, sellerIds) {
    return httpClient.post(`${buyerId}/category/${categoryId}`, sellerIds)
  }
}

export default BuyerCategoryTrafficControlAPI